import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	showMoreTooltip: {
		id: 'issue-field-multi-version-picker-readview-full.multi-version-picker.truncated.show-more-tooltip',
		defaultMessage: 'See more items',
		description: 'Label for trigger button to open a dialog with a list of items',
	},
});
